export default "__VITE_ASSET__Bz9B486g__"